<template>
  <HomeWidgetSmall
    :actionButtonHandler="navigateToExpiredPasswords"
    :hasError="hasError"
    :isLoading="isLoading"
    :metric="numUsersWithExpiredPasswords"
    :metricDescription="metricDescription"
    :widgetType="expiredPasswords"
  />
</template>

<script>
import { ItemTypeConsts, ItemTypeRoutes, StoreModuleMap } from 'client/util/Constants';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapActions, mapGetters } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';
import HomeWidgetSmall from 'client/HomePageV2/widgets/HomeWidgetSmall.vue';
import SystemUserApi from 'client/api/v2/SystemUserApi';
import SystemUserFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/SystemUserFilters';
import Util from 'client/util/Util';

const systemUserCollection = StoreModuleMap[ItemTypeConsts.systemUser];

const {
  widgetTypes,
} = HomeWidgetConsts;

const {
  expiredPasswords,
} = widgetTypes;

const {
  description,
  location,
  section,
  toUrl,
  text: textEventProp,
} = eventProperties;
const {
  homePage,
} = eventLocations;

export default {
  name: 'ExpiredPasswordWidget',

  components: {
    HomeWidgetSmall,
  },

  viewAllRoute: ItemTypeRoutes[ItemTypeConsts.viewExpiredPassword],

  data: () => ({
    expiredPasswords,
    hasError: false,
    isLoading: true,
    numUsersWithExpiredPasswords: 0,
  }),

  computed: {
    ...mapGetters(systemUserCollection, [
      'getDisplayName',
    ]),

    metricDescription() {
      if (this.totalCount === 0) return 'expired passwords';
      if (this.totalCount === 1) return 'user has an expired password';
      return 'users have expired passwords';
    },

    passwordExpiredFilter() {
      return SystemUserFilters.passwordExpired(true);
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    ...mapActions(systemUserCollection, [
      'setFilter',
    ]),

    fetchData() {
      // Search for users with expired passwords
      const sort = '-password_expiration_date';
      const filters = [this.passwordExpiredFilter];
      return SystemUserApi.fetch(null, 3, sort, null, null, filters)
        .then(({ totalCount }) => {
          this.numUsersWithExpiredPasswords = totalCount;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    navigateToExpiredPasswords() {
      EventHelper.triggerWidgetClicked({
        [description]: 'Expired Password Widget - Home Page',
        [location]: homePage,
        [section]: 'Home Widgets',
        [toUrl]: this.$options.viewAllRoute,
        [textEventProp]: 'Expired Password Widget',
      });
      Util.redirect(this.$options.viewAllRoute);
    },
  },
};
</script>
